import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { Col, Row } from "antd";

import { handleloading } from "../../Store/Redux/Reducers/Dashboardreducers";
import {
  AcceptNumbersandLetters,
  AvoidSpace,
  CatchMessage,
  JSONtoformdata,
  Phone_Number_Validation,
  PreventPasting,
  ValidinputData,
  avoidletters,
} from "../../Shared/Methods";
import CommonInput from "../../Components/CommonForms/CommonInput";
import {
  EmailExp,
  MobileExp,
  PasswordExp,
  ProjectID,
  lengths,
} from "../../Shared/Constants";
import emailIcon from "../../Assests/Icons/email.svg";
import passwordIcon from "../../Assests/Icons/password.svg";
import CommonButton from "../../Components/Buttons/CommonButton";
import classes from "./Login.module.css";
import {
  CreateOrganizationCode,
  RegisterApi,
} from "../../Services/ApiServices";
import Loader from "../../SharedComponents/Loader/Loader";
import userIcon from "../../Assests/Images/Vector (74).svg";
import CommonNotification from "../../Components/CommonNotification/CommonNotification";

const validation = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  company_name: Yup.string().required("Company Name is required"),

  email: Yup.string()
    // .min(5, "E-mail should contain at least 5 characters")
    .matches(EmailExp, "E-mail is invalid")
    .required("E-mail is required"),

  confirm_email: Yup.string()
    .oneOf(
      [Yup.ref("email"), undefined],
      `Confirm E-mail must be equal to "E-mail"`
    )
    .required("Confirm E-mail is required"),

  mobile_no: Yup.string()
    .matches(MobileExp, "Invalid Mobile Number")
    .required("Mobile Number is required"),

  alternative_mobile_no: Yup.string().matches(
    MobileExp,
    "Invalid Mobile Number"
  ),

  password: Yup.string()
    .min(5, "Password should contain at least 5 characters")
    .matches(
      PasswordExp,
      "Password must contain at least one lower and upper case character and a digit"
    )
    .required("Password is required"),

  confirm_password: Yup.string()
    .oneOf(
      [Yup.ref("password"), undefined],
      `Confirm Password must be equal to "Password"`
    )
    .required("Confirm Password is required"),

  org_code: Yup.string().required("Organization Code is required"),
  emp_code: Yup.string().required("User Name is required"),
});

function Register() {
  const navigate = useNavigate();
  //   const { LoginData } = useSelector((state: any) => state.Auth);
  const dispatch = useDispatch();
  const { loading } = useSelector((state: any) => state.Dashboard);

  const {
    values,
    errors,
    touched,
    setFieldValue,
    handleSubmit,
    handleBlur,
    setValues,
  } = useFormik({
    initialValues: {
      name: "",
      company_name: "",

      email: "",
      confirm_email: "",

      mobile_no: "",
      alternative_mobile_no: "",

      password: "",
      confirm_password: "",

      emp_code: "",
      org_code: "",
      project_id: "3",
    },
    validationSchema: validation,
    onSubmit: (value) => {
      handleRegister();
    },
  });

  const handleRegister = () => {
    dispatch(handleloading(true));
    const finalObj = {
      ...values,
      ...ProjectID,
    };

    RegisterApi(JSONtoformdata(finalObj))
      .then((res) => {
        if (res?.data?.status === 1) {
          navigate("/otpverification", {
            state: {
              response: { ...res?.data, org_code: values?.org_code },
            },
          });
          toast.success(res?.data?.msg);
        } else if (res?.data?.status === 0) {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => {
        CatchMessage(err);
      })
      .finally(() => dispatch(handleloading(false)));
  };

  const handleOrganizationCode = () => {
    const finalObj = {
      organization_name: values.company_name || "",
      ...ProjectID,
    };

    dispatch(handleloading(true));
    CreateOrganizationCode(JSONtoformdata(finalObj))
      .then((res: any) => {
        if (res?.data?.status === 1) {
          setFieldValue("org_code", res?.data?.org_code);
        }
      })
      .catch((err: any) => {
        CatchMessage(err);
      })
      .finally(() => dispatch(handleloading(false)));
  };

  return (
    <>
      <Loader isLoader={loading} />
      <p className={classes.login_text} style={{ margin: "20px 0px" }}>
        Signup
      </p>

      <form
        onSubmit={handleSubmit}
        className={`primaryInput`}
        id="remove_image"
      >
        <Row gutter={[16, 16]} className={`${classes.registerpageform}`}>
          <Col xl={12} lg={12} md={24} sm={12} xs={24}>
            <CommonInput
              name="company_name"
              value={values?.company_name}
              onChange={({ target }) => {
                setFieldValue("company_name", target.value.trimStart());
              }}
              required={true}
              error={errors}
              touched={touched}
              labelname={"Company Name"}
              maxLength={lengths.Names}
              // onKeyDown={AvoidSpace}
              isInvalid={
                errors.company_name && touched.company_name ? true : false
              }
              onBlur={handleBlur}
            />
          </Col>

          <Col xl={12} lg={12} md={24} sm={12} xs={24}>
            <CommonInput
              name="name"
              value={values?.name}
              onChange={({ target }) => {
                setValues({
                  ...values,
                  name: target.value.trimStart(),
                  // emp_code: target.value.trimStart(),
                });
              }}
              required={true}
              error={errors}
              touched={touched}
              labelname={"Name"}
              onPaste={PreventPasting}
              maxLength={lengths.Names}
              // onKeyDown={AvoidSpace}
              isInvalid={errors.name && touched.name ? true : false}
              // onBlur={(e: any) => {
              //   handleOrganizationCode(e.target.value);
              //   handleBlur(e);
              // }}
              onBlur={handleBlur}
              preIcon={userIcon}
              type="text"
              preIconStyles={{
                width: "19px",
                marginTop: "2px",
              }}
            />
          </Col>

          <Col xl={12} lg={12} md={24} sm={12} xs={24}>
            <CommonInput
              name="emp_code"
              value={values?.emp_code}
              onChange={({ target }) => {
                setValues({
                  ...values,
                  emp_code: target.value.trimStart(),
                });
              }}
              required={true}
              error={errors}
              touched={touched}
              labelname={"User Name"}
              onPaste={PreventPasting}
              maxLength={lengths.Names}
              // onKeyDown={AvoidSpace}
              isInvalid={errors.emp_code && touched.emp_code ? true : false}
              // onBlur={(e: any) => {
              //   handleOrganizationCode(e.target.value);
              //   handleBlur(e);
              // }}
              onBlur={handleBlur}
              preIcon={userIcon}
              type="text"
              preIconStyles={{
                width: "19px",
                marginTop: "2px",
              }}
            />
          </Col>

          <Col xl={12} lg={12} md={24} sm={12} xs={24}>
            <CommonInput
              name="password"
              value={values?.password}
              onChange={({ target }) => {
                // if (!target.value.includes(" ")) {
                setFieldValue("password", target.value);
                // }
              }}
              required={true}
              error={errors}
              touched={touched}
              labelname={"Password"}
              onPaste={PreventPasting}
              maxLength={lengths.Password}
              onKeyDown={AvoidSpace}
              isInvalid={errors.password && touched.password ? true : false}
              onBlur={handleBlur}
              preIcon={passwordIcon}
              type="password"
              preIconStyles={{
                height: "22px",
              }}
            />
          </Col>

          <Col xl={12} lg={12} md={24} sm={12} xs={24}>
            <CommonInput
              name="confirm_password"
              value={values?.confirm_password}
              onChange={({ target }) => {
                if (!target.value.includes(" ")) {
                  setFieldValue("confirm_password", target.value);
                }
              }}
              required={true}
              error={errors}
              touched={touched}
              labelname={"Confirm Password"}
              onPaste={PreventPasting}
              maxLength={lengths.Password}
              onKeyDown={AvoidSpace}
              isInvalid={
                errors.confirm_password && touched.confirm_password
                  ? true
                  : false
              }
              onBlur={handleBlur}
              preIcon={passwordIcon}
              type="password"
              preIconStyles={{
                height: "22px",
              }}
            />
          </Col>

          <Col xl={12} lg={12} md={24} sm={12} xs={24}>
            <CommonInput
              name="email"
              value={values?.email}
              onChange={({ target }) => {
                if (!target.value.includes(" ")) {
                  setFieldValue("email", target.value);
                }
              }}
              required={true}
              error={errors}
              touched={touched}
              labelname={"E-mail"}
              // maxLength={lengths.Names}
              onKeyDown={AvoidSpace}
              isInvalid={errors.email && touched.email ? true : false}
              onBlur={handleBlur}
              preIcon={emailIcon}
              type="text"
              preIconStyles={{
                width: "19px",
                marginTop: "2px",
              }}
            />
          </Col>

          <Col xl={12} lg={12} md={24} sm={12} xs={24}>
            <CommonInput
              name="confirm_email"
              value={values?.confirm_email}
              onChange={({ target }) => {
                if (!target.value.includes(" ")) {
                  setFieldValue("confirm_email", target.value);
                }
              }}
              required={true}
              error={errors}
              touched={touched}
              labelname={"Confirm E-mail"}
              // maxLength={lengths.Names}
              onKeyDown={AvoidSpace}
              isInvalid={
                errors.confirm_email && touched.confirm_email ? true : false
              }
              onBlur={handleBlur}
              preIcon={emailIcon}
              type="text"
              preIconStyles={{
                width: "19px",
                marginTop: "2px",
              }}
            />
          </Col>

          <Col xl={12} lg={12} md={24} sm={12} xs={24}>
            <CommonInput
              name="mobile_no"
              value={values?.mobile_no}
              onChange={({ target }) => {
                Phone_Number_Validation(target) &&
                  setFieldValue("mobile_no", ValidinputData(target.value));
              }}
              required={true}
              error={errors}
              touched={touched}
              labelname={"Mobile Number"}
              maxLength={lengths.Mobile}
              onKeyDown={avoidletters}
              isInvalid={errors.mobile_no && touched.mobile_no ? true : false}
              onBlur={handleBlur}
              // preIcon={passwordIcon}
              type="text"
              // preIconStyles={{
              //   height: "22px",
              // }}
            />
          </Col>

          <Col xl={12} lg={12} md={24} sm={12} xs={24}>
            <CommonInput
              name="alternative_mobile_no"
              value={values?.alternative_mobile_no}
              error={errors}
              onChange={({ target }) => {
                Phone_Number_Validation(target) &&
                  setFieldValue(
                    "alternative_mobile_no",
                    ValidinputData(target.value)
                  );
              }}
              touched={touched}
              labelname={"Alternative Mobile Number"}
              maxLength={lengths.Mobile}
              onKeyDown={AvoidSpace}
              isInvalid={
                errors.alternative_mobile_no && touched.alternative_mobile_no
                  ? true
                  : false
              }
              onBlur={handleBlur}
              // preIcon={passwordIcon}
              type="text"
              // preIconStyles={{
              //   height: "22px",
              // }}
            />
          </Col>

          <Col xl={12} lg={12} md={24} sm={12} xs={24}>
            <CommonInput
              name="org_code"
              value={values?.org_code}
              onChange={(e) => {
                if (AcceptNumbersandLetters(e.nativeEvent.data)) {
                  setFieldValue("org_code", e.target.value);
                }
              }}
              required={true}
              error={errors}
              touched={touched}
              labelname={"Organization Code"}
              onPaste={PreventPasting}
              maxLength={lengths.OrganizationCode}
              // onKeyDown={AvoidSpace}
              isInvalid={errors.org_code && touched.org_code ? true : false}
              onBlur={handleBlur}
              // preIcon={passwordIcon}
              type="text"
              // preIconStyles={{
              //   height: "22px",
              // }}
            />
          </Col>
        </Row>

        {!values?.org_code ? (
          // <Col xl={12} lg={12} md={24} sm={12} xs={24}>
          <div className={classes.generate_code_container}>
            <CommonButton
              name="Generate Code"
              onClick={() => {
                if (values?.company_name) {
                  handleOrganizationCode();
                } else {
                  toast.error(
                    "Fill Company Name to Generate Code or Fill Organization Code"
                  );
                  // <CommonNotification />;
                }
              }}
              type="button"
              style={{
                maxWidth: "153px",
                fontSize: "15px",
                backgroundColor: "#e97f02",
              }}
              classname="geneate_btn"
              // disabled={values?.company_name ? false : true}
            />
          </div>
        ) : // </Col>
        null}

        <div
          className={classes.btn_container}
          style={{
            width: "225px",
            margin: "25px auto 15px",
            // marginTop: "15px",
          }}
        >
          <CommonButton
            name="Signup"
            style={{
              border: "none",
              width: "100px",
              height: "38px",
              color: "white",
              borderRadius: "7px",
            }}
            onClick={() => handleSubmit}
            type="submit"
            classname="submit_btn"
          />
        </div>
        <p style={{ textAlign: "center", fontWeight: "500", margin: "0" }}>
          Already have an account?{" "}
          <span
            style={{ color: "#20a2a0", cursor: "pointer" }}
            onClick={() => navigate("/")}
          >
            Login
          </span>
        </p>
      </form>
    </>
  );
}

export default Register;
